<template>
  <div class="question-media" :class="`question-media--${type}`">
    <img v-if="type === 'image'" class="question-image" :src="src" alt="题目图片">
    <div v-else-if="type === 'video'" class="video-wrap">
      <video ref="videoPlayer" :src="src" playsinline @click="toggleVideo" />
      <button type="button" class="video-play" @click="toggleVideo">
        <span :class="{ pause: videoPlaying }" />
      </button>
    </div>
    <div v-else-if="type === 'audio'" class="audio-player">
      <audio
        ref="audioPlayer"
        :src="src"
        autoplay
        playsinline
        @loadedmetadata="onMetadata"
        @timeupdate="onTimeUpdate"
        @play="playing = true"
        @pause="playing = false"
        @ended="playing = false"
      />
      <div class="audio-progress">
        <span>{{ formatTime(current) }}</span>
        <input v-model.number="current" type="range" min="0" :max="duration || 0" @input="seek">
        <span>{{ formatTime(duration) }}</span>
      </div>
      <div class="audio-controls">
        <img src="@/assets/images/skillCenterQuestion/audio-wave.png" alt="音频波形">
        <button type="button" @click="toggleAudio"><span :class="{ pause: playing }" /></button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SkillCenterQuestionMedia',
  props: {
    src: { type: String, default: '' },
    type: { type: String, default: '' }
  },
  data() {
    return {
      duration: 0,
      current: 0,
      playing: false,
      videoPlaying: false
    }
  },
  mounted() {
    this.autoPlayAudio()
  },
  beforeDestroy() {
    this.pauseAll()
  },
  methods: {
    autoPlayAudio() {
      if (this.type !== 'audio' || !this.$refs.audioPlayer) return
      const playPromise = this.$refs.audioPlayer.play()
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {
          // 浏览器禁止无用户手势播放时，保留手动播放按钮。
        })
      }
    },
    toggleVideo() {
      const video = this.$refs.videoPlayer
      if (!video) return
      if (video.paused) {
        video.play()
        this.videoPlaying = true
      } else {
        video.pause()
        this.videoPlaying = false
      }
    },
    toggleAudio() {
      const audio = this.$refs.audioPlayer
      if (!audio) return
      if (audio.paused) {
        audio.play()
        this.playing = true
      } else {
        audio.pause()
        this.playing = false
      }
    },
    onMetadata(event) {
      this.duration = event.target.duration || 0
    },
    onTimeUpdate(event) {
      this.current = event.target.currentTime || 0
    },
    seek() {
      if (this.$refs.audioPlayer) this.$refs.audioPlayer.currentTime = this.current
    },
    pauseAll() {
      if (this.$refs.audioPlayer) this.$refs.audioPlayer.pause()
      if (this.$refs.videoPlayer) this.$refs.videoPlayer.pause()
    },
    formatTime(value) {
      const seconds = Math.max(0, Number(value) || 0)
      const minute = Math.floor(seconds / 60)
      const second = Math.floor(seconds % 60)
      return `${String(minute).padStart(2, '0')}:${String(second).padStart(2, '0')}`
    }
  }
}
</script>

<style lang="scss" scoped>
.question-media {
  margin: 16px 20px 18px;
}

.question-image,
.video-wrap,
.video-wrap video {
  display: block;
  width: 100%;
  border-radius: 10px;
}

.question-image,
.video-wrap video {
  max-height: 250px;
  object-fit: contain;
}

.video-wrap {
  position: relative;
  overflow: hidden;
  background: #000000;
}

.video-play {
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: rgba(63, 63, 63, 0.6);
  transform: translate(-50%, -50%);
}

.video-play span,
.audio-controls button span {
  width: 0;
  height: 0;
  margin-left: 3px;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 14px solid #ffffff;
}

.video-play span.pause,
.audio-controls button span.pause {
  width: 11px;
  height: 20px;
  margin-left: 0;
  border: 0;
  border-right: 4px solid #ffffff;
  border-left: 4px solid #ffffff;
}

.audio-player {
  padding: 21px 0 4px;
}

.audio-progress {
  display: grid;
  grid-template-columns: 52px 1fr 52px;
  align-items: center;
  color: #9497aa;
  font-size: 11px;
  text-align: center;
}

.audio-progress input {
  width: 100%;
  height: 3px;
  margin: 0;
  accent-color: #1abf97;
}

.audio-controls {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 78px;
  margin-top: 12px;
}

.audio-controls > img {
  width: 218px;
  height: 24px;
  object-fit: contain;
  opacity: 0.55;
}

.audio-controls button {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: #16bd94;
}
</style>
